import pipe from 'lodash/fp/pipe';
import toLower from 'lodash/fp/toLower';
import replace from 'lodash/fp/replace';
import classes from '@nerdwallet/base-styles/classes';

export default (color) =>
  color
    ? pipe(
        replace('CHARCOAL', 'neutral-darkest'),
        toLower,
        classes
      )(`color-${color}`)
    : '';
